export enum InvoiceStatusKey {
  Open = 'open',
  PaidInFull = 'paidInFull',
  PendingApproval = 'pendingApproval',
  Rejected = 'rejected',
  Voided = 'voided',
  Undefined = 'undefined',
}

export interface CompanyPaymentsPageInvoiceStatusViewModel {
  id: string;
  key: InvoiceStatusKey;
  name: string;
  isOverdue: boolean;
}

export interface CompanyPaymentsSubsidiaryViewModel {
  id: string;
  name: string;
}

export interface CompanyPaymentsPageInvoiceViewModel {
  id: string;
  invoiceNumber: string;
  companyName: string;
  companyId: string;
  orderDate: Date;
  totalAmount: number;
  previousPayments: number;
  balanceDue: number;
  subsidiaryId: string;
  status: CompanyPaymentsPageInvoiceStatusViewModel;
  programId: string;
  dueDate?: Date;
}

export interface CompanyPaymentsPageCompanyViewModel {
  id: string;
  name: string;
  subsidiaries: CompanyPaymentsSubsidiaryViewModel[]; // entity.subsidiary or CustomerSubsidiaryMap.subsidiary
  invoices: CompanyPaymentsPageInvoiceViewModel[];
}

export interface CompanyPaymentsPageViewModel {
  companyDetails: CompanyPaymentsPageCompanyViewModel[];
}

export default CompanyPaymentsPageViewModel;
